module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_tablet.68f17848.jpg";